module.exports = __webpack_public_path__ + "static/media/clock.f6ccf881.svg";